import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Home01Icon } from '@untitledui-icons/react/line'
import { Logo } from '@/components/layout/Logo'

export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-cream px-4 dark:bg-gray-950">
      <div className="mb-8">
        <Logo width={140} />
      </div>
      
      <div className="text-center">
        <p className="mb-2 text-sm font-semibold text-brand-600 dark:text-brand-400">
          {t('errors.error_404')}
        </p>
        <h1 className="mb-4 text-4xl font-bold text-gray-900 dark:text-white sm:text-5xl">
          {t('errors.page_not_found')}
        </h1>
        <p className="mb-8 text-lg text-gray-500 dark:text-gray-400">
          {t('errors.page_not_found_description')}
        </p>
        <Link
          to="/dashboard"
          className="
            inline-flex items-center gap-2 rounded-lg
            bg-brand-500 px-4 py-2.5 text-sm font-semibold text-white
            transition-colors hover:bg-brand-600
            focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2
          "
        >
          <Home01Icon className="h-4 w-4" />
          {t('errors.go_home')}
        </Link>
      </div>
    </div>
  )
}

export default NotFoundPage
